import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './PageLoader.css';

export default function PageLoader() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    const timer = setTimeout(() => setVisible(false), 700);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div className="page-loader">
      <div className="loader-content">
        <div className="loader-ring">
          <div className="loader-ring-inner" />
        </div>
        <img src={logo} alt="Aarambh" className="loader-logo" />
      </div>
    </div>
  );
}
